import React, { useCallback } from 'react'
import { styled, SxProps } from '@mui/material/styles'
import { FormControlLabel, Checkbox, IconButton } from '@mui/material'
import { Delete } from '@/icon'
import Text from '@/components/Text'
export interface ListItemProps {
  checkable: boolean
  selected?: boolean
  onSelect?: (checked: boolean) => void
  onDelete?: () => void
  text: string
  sx?: SxProps
}

const ListItemWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0 16px',
  backgroundColor: '#fff',
  justifyContent: 'space-between',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: 'rgba(32, 108, 255, 0.06)',
    transition: 'all 0.2s ease-in-out',
  },
}))
const ListItem: React.FC<ListItemProps> = (props) => {
  const { checkable, selected, onSelect, onDelete, text, sx } = props

  const handleSelect = useCallback(
    (event: React.SyntheticEvent<HTMLInputElement>) => {
      // @ts-ignore
      const checked = event?.target?.checked as boolean
      // @ts-ignore
      onSelect(checked)
    },
    [onSelect],
  )

  return (
    <ListItemWrapper sx={{ ...sx }}>
      {checkable ? (
        <FormControlLabel
          label={
            <Text sx={{ fontSize: '16px' }} weight='regular'>
              {text}
            </Text>
          }
          // @ts-ignore
          onChange={handleSelect}
          checked={selected}
          control={<Checkbox />}
        />
      ) : (
        <>
          <Text sx={{ fontSize: '16px', lineHeight: '40px' }} weight='regular'>
            {text}
          </Text>
          <IconButton size='small'>
            <Delete sx={{ fontSize: '16px', color: 'primary.main', cursor: 'pointer' }} onClick={onDelete} />
          </IconButton>
        </>
      )}
    </ListItemWrapper>
  )
}

export default ListItem
